'use client';

import { Box } from "@chakra-ui/react"
import Link from "next/link"
import { useEffect, useState } from "react"
import { handleKarmaNavigation, refineUrlDomain } from "../utils";
import config from "config";
import forEach from 'lodash/forEach';
import { useSearchParams } from 'next/navigation';
import { useCookies } from 'react-cookie';


let SimpleButton = ({ sectionContent, language }) => {

    const searchParams = useSearchParams();
    const [currentUrl, setCurrentUrl] = useState('');
    const cookieParams = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
    ];
    const [cookies, setCookie] = useCookies(cookieParams);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        cookieParams.forEach((cookie) => {
            const value = searchParams.get(cookie);
            if (value) {
                setCookie(cookie, value, {
                    path: '/',
                    maxAge: 3600 * 24 * 365,
                    sameSite: true,
                    domain: config.COOKIE_DOMAIN,
                    secure: true,
                });
                console.log(`Cookie ${cookie} set to ${value}`);
            }
        });
    }, [searchParams]);

    useEffect(() => {
        if (sectionContent?.linkUrl) {
            setCurrentUrl(refineUrlDomain(sectionContent?.linkUrl))
        }
    }, [sectionContent])


    if (sectionContent?.buttonStyle === 'karma-transparent') {
        return <Link
            href={currentUrl}
            width={'326px'}
        >
            <Box
                bgColor={'#00000033'}
                position={'relative'}
                border={'2px solid #FFFFFF'}
                borderRadius={'10px'}
                width={{ base: '210px', md: '202px', lg: '257px' }}
                fontFamily={'var(--AustinMedium)'}
                color={'#fff'}
                fontSize={{ base: '22px', lg: '28px' }}
                textAlign={'center'}
                lineHeight={{ base: '54px', md: '63px', lg: '80px' }}
                justifyContent={'center'}
                fontWeight={500}
                pr={'30px'}
                _hover={{
                    bgColor: '#00000066'
                }}
            >{sectionContent?.buttonText}
                <Box position={'absolute'} right={{ base: '1.2rem', md: '1rem', lg: "1.4rem" }} top={{ base: '42%', md: '40%', lg: '44%' }}>
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.8333 1.5L16.3333 6.99998M16.3333 6.99998L10.8333 12.5M16.3333 6.99998L1.66658 6.99998" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Box>
            </Box>
        </Link>
    }
    else {
        return <Link
            href={currentUrl}
        >
            <Box
                mt={{ base: '0px', md: '10px' }}
                ml={{ base: '15px', md: '10px', lg: '15px' }}
                bgColor={'#FFFFFF4D'}
                position={'relative'}
                border={'2px solid #B7870C'}
                borderRadius={'10px'}
                width={{ base: '185px', md: '223px' }}
                fontFamily={'var(--AustinMedium)'}
                fontWeight={500}
                color={'#B7870C'}
                fontSize={{ base: '22px', md: '28px' }}
                textAlign={'center'}
                lineHeight={{ base: '60px', md: '80px' }}
                justifyContent={'center'}
                paddingRight={'30px'}
                _hover={{
                    bgColor: "#030040",
                    color: '#B7870C',
                    border: '2px solid #B7870C'
                }}
            >{sectionContent?.buttonText}
                <Box position={'absolute'} right={{ base: '1.2rem', md: '1.3rem', lg: "1.4rem" }} top={{ base: '42%', md: '44%', }}>
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.8333 1.5L16.3333 6.99998M16.3333 6.99998L10.8333 12.5M16.3333 6.99998L1.66658 6.99998" stroke="#B7870C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Box>
            </Box>
        </Link>
    }
}

export default SimpleButton;